// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1Dg3P","title":"Images45_title__3zekI","images":"Images45_images__1Tboo"};